import { render, staticRenderFns } from "./_fornecedores.tab.vue?vue&type=template&id=3eb6ad0c&scoped=true"
import script from "./_fornecedores.tab.vue?vue&type=script&lang=js"
export * from "./_fornecedores.tab.vue?vue&type=script&lang=js"
import style0 from "./_fornecedores.tab.vue?vue&type=style&index=0&id=3eb6ad0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb6ad0c",
  null
  
)

export default component.exports